import React, { useState, useEffect } from 'react';

function ConnectButton() {
  const [status, setStatus] = useState('disconnected');
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [polling, setPolling] = useState(false);

  // Obter userId do localStorage
  const getUserId = () => {
    const user = JSON.parse(localStorage.getItem('zaptime_user') || '{}');
    return user.id;
  };

  // Headers com userId
  const getHeaders = () => ({
    'Content-Type': 'application/json',
    'X-User-Id': getUserId()
  });

  // Verificar status a cada 3 segundos
  useEffect(() => {
    const interval = setInterval(checkStatus, 3000);
    return () => clearInterval(interval);
  }, []);

  // Polling do QR Code quando estiver aguardando
  useEffect(() => {
    let qrInterval;
    
    if (polling) {
      console.log('🔄 Iniciando polling do QR Code...');
      
      // Buscar imediatamente
      fetchQRCode();
      
      // E a cada 2 segundos
      qrInterval = setInterval(fetchQRCode, 2000);
    }
    
    return () => {
      if (qrInterval) {
        clearInterval(qrInterval);
      }
    };
  }, [polling]);

  const checkStatus = async () => {
    try {
      const response = await fetch('/api/status', {
        headers: getHeaders()
      });
      
      if (!response.ok) {
        console.error('Erro ao verificar status:', response.status);
        return;
      }
      
      const data = await response.json();
      console.log('Status:', data);

      // LÓGICA MELHORADA: Considerar connected OU hasClient+keepAlive
      const isReallyConnected = data.connected || (data.hasClient && data.keepAliveActive);

      if (isReallyConnected) {
        console.log('✅ Conectado (backend ativo)!');
        setStatus('connected');
        setQrCode(null);
        setPolling(false);
      } else if (data.hasClient || data.hasQR) {
        console.log('⏳ Aguardando QR Code ou conexão...');
        
        // Só muda status se ainda não estiver em waiting_qr
        // Isso evita re-render que limpa o QR Code
        if (status !== 'waiting_qr') {
          setStatus('waiting_qr');
        }
        
        // Mantém polling ativo
        setPolling(true);
      } else {
        // Só limpa se realmente desconectou
        if (status !== 'disconnected') {
          console.log('❌ Desconectado (sem cliente no backend)');
          setStatus('disconnected');
          setQrCode(null);
          setPolling(false);
        }
      }
    } catch (error) {
      console.error('Erro ao verificar status:', error);
    }
  };

  const fetchQRCode = async () => {
    try {
      const response = await fetch('/api/qrcode', {
        headers: getHeaders()
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.qrImage) {
          console.log('✅ QR Code recebido!');
          // Só atualiza se mudou (evita re-render desnecessário)
          setQrCode(prev => prev !== data.qrImage ? data.qrImage : prev);
        } else {
          console.log('⏳ QR Code ainda não disponível:', data.status);
        }
      } else if (response.status === 202) {
        // 202 = Aguardando
        console.log('⏳ Aguardando QR Code (202)...');
      } else {
        console.log('❌ Erro ao buscar QR:', response.status);
      }
    } catch (error) {
      console.error('Erro ao buscar QR Code:', error);
    }
  };

  const handleConnect = async () => {
    setLoading(true);
    setQrCode(null);
    
    try {
      const userId = getUserId();
      console.log('📞 Conectando com userId:', userId);
      
      const response = await fetch('/api/connect', {
        headers: getHeaders()
      });
      
      const data = await response.json();
      console.log('Resposta do connect:', data);
      
      alert(data.message);
      setStatus('waiting_qr');
      setPolling(true);
      
    } catch (error) {
      console.error('Erro ao conectar:', error);
      alert('Erro ao conectar: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Tem certeza que deseja desconectar?')) {
      return;
    }

    setLoading(true);
    setPolling(false);
    
    try {
      const response = await fetch('/api/disconnect', {
        method: 'POST',
        headers: getHeaders()
      });
      const data = await response.json();
      
      if (data.success) {
        alert('Desconectado com sucesso!');
        setStatus('disconnected');
        setQrCode(null);
      } else {
        alert(data.message || 'Erro ao desconectar');
      }
    } catch (error) {
      alert('Erro ao desconectar');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: '20px', padding: '20px', border: '2px solid #ddd', borderRadius: '10px' }}>
      <h2>📱 Conexão WhatsApp</h2>
      
      {status === 'disconnected' && (
        <div>
          <p>Conecte seu WhatsApp para ativar o bot.</p>
          <button 
            onClick={handleConnect} 
            disabled={loading}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: loading ? '#ccc' : '#25D366',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: 'bold'
            }}
          >
            {loading ? '⏳ Conectando...' : '🔗 Conectar WhatsApp'}
          </button>
        </div>
      )}

      {status === 'waiting_qr' && (
        <div style={{ textAlign: 'center' }}>
          <h3>📱 Escaneie o QR Code com seu WhatsApp</h3>
          
          {qrCode ? (
            <div>
              <img 
                src={qrCode} 
                alt="QR Code" 
                style={{ 
                  maxWidth: '300px', 
                  border: '3px solid #25D366',
                  borderRadius: '10px',
                  padding: '10px',
                  backgroundColor: 'white'
                }} 
              />
              <p style={{ color: '#25D366', marginTop: '10px' }}>
                ✅ QR Code gerado! Escaneie agora.
              </p>
            </div>
          ) : (
            <div>
              <p style={{ fontSize: '48px' }}>⏳</p>
              <p>Gerando QR Code...</p>
              <p style={{ fontSize: '12px', color: '#666' }}>
                (Aguarde alguns segundos)
              </p>
            </div>
          )}
        </div>
      )}

      {status === 'connected' && (
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: '#25D366', fontSize: '20px', fontWeight: 'bold' }}>
            ✅ WhatsApp Conectado!
          </p>
          <p>Seu bot está ativo e pronto para responder mensagens.</p>
          <button 
            onClick={handleDisconnect}
            disabled={loading}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: loading ? '#ccc' : '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginTop: '15px',
              fontWeight: 'bold'
            }}
          >
            {loading ? '⏳ Desconectando...' : '🔴 Desconectar'}
          </button>
        </div>
      )}
      
      {/* Debug info */}
      <div style={{ marginTop: '20px', fontSize: '12px', color: '#999', borderTop: '1px solid #eee', paddingTop: '10px' }}>
        <p>Status: {status} | Polling: {polling ? 'Ativo' : 'Inativo'} | User ID: {getUserId()}</p>
      </div>
    </div>
  );
}

export default ConnectButton;